import { ActionTree } from 'vuex'
import { RootState } from '@/store'
import { CompanyAPI } from '@/api/backend-client'
import { PipelineConnectionsState } from './index'

export const actions: ActionTree<PipelineConnectionsState, RootState> = {
    async loadPipelineConnections({ commit }) {
        commit('loadPipelineConnections', true)

        try {
            const incomingConnections = await CompanyAPI.getIncomingConnections()
            const outgoingConnections = await CompanyAPI.getOutgoingConnections()
            commit('loadPipelineConnectionsSuccess', { incomingConnections, outgoingConnections })

        } catch (error) {
            commit('loadPipelineConnectionsFailure', error.message)
        }
    },
}
